import React, { useState } from "react";
import {Button, FormFeedback, Modal, ModalBody, ModalHeader, Spinner} from "reactstrap";
import { useSelector } from "react-redux";
import { useCreateCreditCard } from "../api/createCreditCard";
import { detectBank } from "../util/detectBank";
import { ReactComponent as AddCardIcon } from "@src/assets/images/wallet/addCard.svg";
import {z} from "zod";
import {Controller, useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import Cleave from "cleave.js/react";
import classnames from "classnames";

const defaultValues = {
  cardNumber: "",
  shabaNumber: "",
};

const validationSchema = z.object({

  cardNumber: z
      .string()
      .min(16, "Card number must be 16 digits") // Check if the input is empty
      .transform((val) => val.replace(/[^0-9]/g, "")) // Remove non-numeric characters
      .pipe(
          z.coerce
              .number()
              .int()
              .positive("Card Number must be an integer")
      ),

  shabaNumber: z
      .string()
      .min(24, "IBAN must be 24 digits") // Check if the input is empty
      .transform((val) => val.replace(/[^0-9]/g, "")) // Remove non-numeric characters
      // .pipe(
      //     z.coerce
      //         .number()
      //         .int()
      //         .positive("IBAN must be an integer")
      // ),

});

export const AddCardModal = ({ addCardModal, setAddCardModal }) => {

  const authStore = useSelector((state) => state.auth);

  const createCreditCardMutation = useCreateCreditCard({
    config: {
      onSuccess: () => {
          reset()
        setAddCardModal(false);
      },
    },
  });

  const {
    control,
    handleSubmit,
      reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(validationSchema),
    defaultValues,
  });


  const onSubmit = (data) => {
console.log(data)
    createCreditCardMutation.mutateAsync({
      data: {
        title: data.cardNumber,
        bank: detectBank(data.cardNumber)?.bank_name,
        card_id: data.cardNumber,
        hesab_id: data.cardNumber,
        shaba_id: data.shabaNumber,
        first_name: authStore.userData.first_name,
        last_name: authStore.userData.last_name,
      },
    });
  };

  return (
    <div className="demo-inline-spacing">
      <div className="vertically-centered-modal">
        <Modal
            isOpen={addCardModal}
            toggle={() => setAddCardModal(!addCardModal)}
            className="modal-dialog-centered"
        >
          <ModalHeader
              toggle={() => setAddCardModal(!addCardModal)}
              className={"bg-dark"}
          ></ModalHeader>
          <form onSubmit={handleSubmit(onSubmit)}>

            <ModalBody className="bg-dark">
              <div
                  className={
                    "d-flex align-items-center gap-1 justify-content-center mb-2"
                  }
              >
                <div className={"bg-primary rounded-circle p-50"}>
                  <AddCardIcon/>
                </div>
                <h3 className={"m-0"}>Add new card</h3>
              </div>
              <div className="form-floating mb-1">
                <Controller
                    id="cardNumber"
                    name="cardNumber"
                    rules={{required: true}}
                    control={control}
                    render={({field: {onChange, onBlur, ref}}) => (
                        <Cleave
                            className={classnames("form-control bg-secondary", {
                              "is-invalid rounded height-65": errors.cardNumber,
                            })}
                            placeholder=""
                            options={{creditCard: true,
                              rawValueTrimPrefix: true,
                            }}
                            inputRef={ref}
                            onChange={onChange}
                            onBlur={onBlur}
                            id="cardNumber"
                            invalid={errors.cardNumber && true}
                        />
                    )}
                />
                <label htmlFor="cardNumber">Card number</label>
                {errors.cardNumber && (
                    <FormFeedback className="d-block mt-50">
                      {errors.cardNumber.message}
                    </FormFeedback>
                )}
              </div>

              <div className="form-floating ">
                <Controller
                    id="shabaNumber"
                    name="shabaNumber"
                    rules={{required: true}}
                    control={control}
                    render={({field: {onChange, onBlur, ref}}) => (
                        <Cleave
                            className={classnames("form-control bg-secondary", {
                              "is-invalid rounded height-65 ": errors.shabaNumber,
                            })}
                            placeholder=""
                            options={{prefix: "IR",
                                blocks: [24],
                                numericOnly:true,
                                rawValueTrimPrefix: true,

                            }}
                            inputRef={ref}
                            onChange={onChange}
                            onBlur={onBlur}
                            id="shabaNumber"
                            invalid={errors.shabaNumber && true}
                        />
                    )}
                />
                <label htmlFor="shabaNumber">IBAN</label>
                {errors.shabaNumber && (
                    <FormFeedback className="d-block mt-50">
                      {errors.shabaNumber.message}
                    </FormFeedback>
                )}
              </div>

              <Button
                  block
                  size={"lg"}
                  color="primary"
                  className="rounded-3 mb-1 mt-2"
                  type={'submit'}
              >
                {createCreditCardMutation.isLoading ||
                createCreditCardMutation.isPending ? (
                    <Spinner size={"sm"}/>
                ) : (
                    "Add Card"
                )}
              </Button>
            </ModalBody>
          </form>
        </Modal>
      </div>
    </div>
  );
};
